import styled from 'styled-components';
import color from '../../../../config/colors.json';

export const Details = styled.div`
	> * {
		font-family: 'Poppins', Arial, Helvetica, sans-serif;
	}
`;

export const Info = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin: 24px 0;
	& [role^='cell'] {
		> em, > span {
			display: block;
			font-style: normal;
			font-family: 'Poppins', sans-serif;
		}
		> span {
			color: ${color.lightGrey10a};
			font-size: 8px;
			line-height: 11px;
		}
		> em {
			line-height: 20px;
			font-size: 14px;
			margin-top: 9px;
		}
	}
`;
